import comp from "./SwitcherComponent";
export default comp;
